export default "__VITE_ASSET__Bkw6Aiyc__"